// extracted by mini-css-extract-plugin
module.exports = {"container":"Theme_container__7mo2y","sunIcon":"Theme_sunIcon__3RobH","moonIcon":"Theme_moonIcon__3qOAN","switch":"Theme_switch__2USdQ","switchLabel":"Theme_switchLabel__3Ot7l"};